export default {"hash":"4e9e11f0c24edc02","text":"<div class=\"commits-list\"></div>"};